import { I18n } from 'aws-amplify'
import { translations } from '@aws-amplify/ui-react'

import i18n from './init-i18n'

I18n.putVocabularies(translations)
I18n.setLanguage(i18n.language)
